import { computed } from 'vue';
import Widget from '../Widget/Widget';
import { WidgetTypes } from 'interfaces';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { store } from '@/store/store';
import ITrackingObject from '@/interfaces/tracking-object.interface';
import { Action, Product } from '@studyportals/datalake-event-tracker';
import globals from '@/utils/globals';

export default class MainDeterminant extends Widget {
	private imageBaseUrl = '//monet-prtl-co.imgix.net/Shared/BestFit';

	constructor(
		studyId: number,
		widgetType: WidgetTypes,
		widgetLocation: string,
		emptyText: string,
		determinantType: ScoreDeterminantType,
	) {
		super(studyId, widgetType, widgetLocation, emptyText, determinantType);
	}

	public beforeMount(): void {
		store.mutations.setActiveStudyId(this.studyId);
	}

	public imageSource = computed((): string => {
		switch (this.determinantType) {
		case ScoreDeterminantType.ACADEMIC_FIT:
			return `${this.imageBaseUrl}/Academic.svg`;
		case ScoreDeterminantType.BUDGET_FIT:
			return `${this.imageBaseUrl}/Budget.svg`;
		default:
			return `${this.imageBaseUrl}/Academic.svg`;
		}
	});

	public DeterminantTypeText = computed((): string => {
		switch (this.determinantType) {
		case ScoreDeterminantType.ACADEMIC_FIT:
			return 'Academic fit';
		case ScoreDeterminantType.BUDGET_FIT:
			return 'Budget fit';
		default:
			return 'Academic fit';
		}
	});

	public DeterminantTypeTextForTracking = computed((): string => {
		switch (this.determinantType) {
		case ScoreDeterminantType.ACADEMIC_FIT:
			return 'academic_fit';
		case ScoreDeterminantType.BUDGET_FIT:
			return 'budget_fit';
		default:
			return 'academic_fit';
		}
	});

	public determinantScore = computed((): number => {
		return (
			store.getters
				.getActiveStudyStore()
				?.getters.scoreByDeterminant(
					this.determinantType as ScoreDeterminantType,
				) ?? 0
		);
	});

	public trackIncentiveClick(): void {
		const trackingParams: ITrackingObject = {
			category: Product.BESTFIT_OVERVIEW,
			action: Action.CLICK,
			label: `widget_${this.widgetType}@${this.widgetLocation}_determinanttype_${this.DeterminantTypeTextForTracking?.value}`,
			property: String(this.studyId),
			value: this.bestFitScore.value!,
		};

		globals.bestFitTracking.snowPlow(trackingParams);
	}

	public incentiveClicked(): void {
		store.actions.incentiveClicked();
		this.trackIncentiveClick();
		store.mutations.setActiveMainDeterminant(
			this.determinantType as ScoreDeterminantType,
		);
	}
}
